document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-correnva-mosaic]');
  sections.forEach((section) => {
    if (section.classList.contains('correnva-mosaic--reveal')) {
      window.requestAnimationFrame(() => section.classList.add('is-visible'));
    }
  });

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const motionItems = document.querySelectorAll('[data-correnva-motion]');
  if (!('IntersectionObserver' in window)) {
    motionItems.forEach((item) => item.classList.add('is-in-view'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in-view');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  motionItems.forEach((item) => {
    if (item.getBoundingClientRect().top < window.innerHeight * 1.05) item.classList.add('is-in-view');
    else observer.observe(item);
  });
});
